import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { RatingService, RatingRequest } from '../../api/services/rating.service';
import { Rating } from '../../api/models';
import { HeaderNavComponent } from 'src/app/ui/header-nav/header-nav.component';
import { FooterComponent } from 'src/app/ui/footer/footer.component';

@Component({
  selector: 'app-ratings',
  standalone: true,
  imports: [
    CommonModule, MatCardModule, MatButtonModule, MatIconModule,
    MatFormFieldModule, MatInputModule, MatSnackBarModule,
    MatProgressSpinnerModule, FormsModule,
    HeaderNavComponent, FooterComponent
  ],
  templateUrl: './ratings.component.html'
})
export class RatingsComponent implements OnInit {
  isLoading = false;
  ratings: Rating[] = [];
  ratingStars = [1, 2, 3, 4, 5];

  newRating: RatingRequest = { rating: 5, comment: '', subject: 'Service' };
  showSubmitForm = false;

  constructor(
    private ratingService: RatingService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadRatings();
  }

  loadRatings(): void {
    this.isLoading = true;
    this.ratingService.getServiceRatings().subscribe({
      next: (data) => {
        this.ratings = data;
        this.isLoading = false;
      },
      error: () => this.isLoading = false
    });
  }

  submitRating(): void {
    if (!this.newRating.comment.trim()) {
      this.snackBar.open('Please add a comment', 'Close', { duration: 3000 });
      return;
    }
    // This screen has no bar context, so there is nothing to attach a rating to.
    // It used to POST /ratings/client/rate — a route from the old meethousepros
    // service that no longer exists, so every submission failed silently behind
    // a "Failed to submit rating" toast. Ratings are derived from the feedback
    // left after a visit, and a specific bar can be rated from its own page.
    this.snackBar.open(
      'Ratings come from the feedback you leave after a visit. To rate a bar, open it from Bars.',
      'Close', { duration: 6000 });
    this.showSubmitForm = false;
  }

  getAverageRating(): number {
    if (!this.ratings.length) return 0;
    return this.ratings.reduce((sum, r) => sum + r.rating, 0) / this.ratings.length;
  }

  onBack(): void {
    this.router.navigate(['/']);
  }
}
